import { motion } from 'framer-motion';

export default function CTA() {
  return (
    <section className="bg-gray-50 py-20 sm:py-28 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="mb-8 sm:mb-12 rounded-2xl sm:rounded-[32px] overflow-hidden mx-auto max-w-6xl">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-64 sm:h-96 lg:h-[500px] object-cover object-top"
              aria-label="Transforme seu terreno em Ilhabela em uma residência autoral"
              poster="https://public.readdy.ai/ai/img_res/5ec3a2d50d91d2f4fbc26e23169fa371.jpg"
            >
              <source src="https://public.readdy.ai/ai/video_res/f1cc2799-8c74-4306-89a6-4a5fcdf873da.mp4" type="video/mp4" />
              Seu navegador não suporta vídeos HTML5.
            </video>
          </div>

          <div className="max-w-3xl mx-auto mb-8 sm:mb-12 px-4">
            <h2 className="font-playfair text-2xl sm:text-3xl lg:text-5xl leading-relaxed">
              <span className="font-normal text-gray-700">Transforme seu</span>
              <br />
              <span className="font-light italic text-gray-600">terreno em Ilhabela</span>
              <br />
              <span className="font-bold text-gray-900">em uma residência autoral</span>
            </h2>
          </div>

          <a
            href="https://wa.me/5512974034577"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-8 sm:px-12 py-4 sm:py-5 bg-gray-900 text-white text-sm sm:text-base font-inter font-medium rounded-full hover:bg-gray-800 transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
            Solicitar Conversa
          </a>
        </motion.div>
      </div>
    </section>
  );
}
